import React, { Component } from "react";
import { connect } from "react-redux";

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldRender: false,
      isVisible: false
    };
    this.timeout = null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.loading.actief && !prevProps.loading.actief) {
      this.setState({ shouldRender: true }, () => {
        requestAnimationFrame(() => this.setState({ isVisible: true }));
      });
    } else if (!this.props.loading.actief && prevProps.loading.actief) {
      this.setState({ isVisible: false });
      this.timeout = setTimeout(() => {
        this.setState({ shouldRender: false });
      }, 400);
    }
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  render() {
    if (!this.state.shouldRender) {
      return null;
    }

    return (
      <div className={`loadingmessage animated-toast ${this.state.isVisible ? 'fade-in' : 'fade-out'}`}>
        <div className={"callout callout-" + this.props.loading.soort}>
          <p>{this.props.loading.message}</p>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { loading: state.loading.message };
}

export default connect(mapStateToProps, {})(Loading);
